import { Button } from '@ui/components/base/buttons/button';
import { Callout } from '@ui/console/primitives';
import { Page } from './components';

export function NotFound() {
  return (
    <Page
      title="Page not found"
      description="The requested Stylist workspace page does not exist."
      actions={
        <Button size="sm" color="secondary" href="/">
          Back to my members
        </Button>
      }
    >
      <Callout tone="neutral" title="Nothing at this address">
        This address does not match a Stylist workspace page.
      </Callout>
    </Page>
  );
}
